import s from "styled-components";
import { Base as l, VisuallyHidden as a } from "./atoms-v2777.js";
const d = ({
  colorTheme: n = "light",
  isChecked: i,
  isDisabled: t,
  isReadOnly: o,
  isSkeleton: r,
  theme: g
}) => r ? g == null ? void 0 : g.get(`ui.toggle.${n}.skeletonBkg`) : t ? g == null ? void 0 : g.get(`ui.toggle.${n}.bkgDisabled`) : o ? "transparent" : i ? g == null ? void 0 : g.get(`ui.toggle.${n}.bkgOn`) : g == null ? void 0 : g.get(`ui.toggle.${n}.bkgOff`), u = ({
  colorTheme: n,
  isDisabled: i,
  isReadOnly: t,
  isSkeleton: o,
  theme: r
}) => o ? r == null ? void 0 : r.get(`ui.toggle.${n}.skeletonElm`) : i ? r == null ? void 0 : r.get(`ui.toggle.${n}.off`) : t ? r == null ? void 0 : r.get(`ui.toggle.${n}.bkgOn`) : r == null ? void 0 : r.get(`ui.toggle.${n}.active`), $ = ({
  colorTheme: n,
  isFocused: i,
  isReadOnly: t,
  theme: o
}) => i ? o == null ? void 0 : o.get(`ui.toggle.${n}.focus`) : t ? o == null ? void 0 : o.get(`tokens.border.${n}.dark`) : "transparent", p = s.div`
  ${l}
  ${({ $size: n, theme: i }) => {
  var t, o;
  return n === "default" ? (t = i == null ? void 0 : i.get("tokens.body.productive")) == null ? void 0 : t.toJS() : (o = i == null ? void 0 : i.get("tokens.helper.productive")) == null ? void 0 : o.toJS();
}}
  min-width: 92px;
  width: ${({ $display: n }) => n === "inline" ? "auto" : "100%"};
`, k = s.input`
  ${a}
`, x = s.label`
  align-items: center;
  column-gap: 8px;
  cursor: ${({ $isDisabled: n, $isReadOnly: i }) => n || i ? "default" : "pointer"};
  display: ${({ $display: n, $isSkeleton: i }) => n === "inline" && !i ? "inline-flex" : "flex"};
`, b = s.div`
  color: ${({ $colorTheme: n = "light", theme: i }) => i == null ? void 0 : i.get(`tokens.text.${n}.primary`)};
  flex-grow: 1;
  text-align: ${({ $isRightPosition: n }) => n ? "right" : "left"};
`, S = s.div`
  align-items: center;
  background-color: ${({ $colorTheme: n = "light", $isChecked: i, $isDisabled: t, $isReadOnly: o, $isSkeleton: r, theme: g }) => d({
  colorTheme: n,
  isChecked: i,
  isDisabled: t,
  isReadOnly: o,
  isSkeleton: r,
  theme: g
})};
  border-radius: 24px;
  display: flex;
  height: ${({ $size: n }) => n === "default" ? "24px" : "22px"};
  justify-content: center;
  outline-color: ${({ $colorTheme: n = "light", $isFocused: i, $isReadOnly: t, theme: o }) => $({ colorTheme: n, isFocused: i, isReadOnly: t, theme: o })};
  outline-offset: ${({ $isReadOnly: n }) => n ? "0px" : "2px"};
  outline-style: solid;
  /* stylelint-disable-next-line declaration-block-no-redundant-longhand-properties */
  outline-width: ${({ $isReadOnly: n }) => n ? "1px" : "2px"};
  transition:
    background-color ${({ theme: n }) => n == null ? void 0 : n.get("tokens.motion").toString("duration.fast")}
      ${({ theme: n }) => n == null ? void 0 : n.get("tokens.motion").toString("easing.standard")},
    outline ${({ theme: n }) => n == null ? void 0 : n.get("tokens.motion").toString("duration.fast")}
      ${({ theme: n }) => n == null ? void 0 : n.get("tokens.motion").toString("easing.standard")};
  width: ${({ $size: n }) => n === "default" ? "48px" : "40px"};
`, y = s.div`
  --size: ${({ $size: n }) => n === "default" ? "18px" : "14px"};

  background-color: ${({ $colorTheme: n = "light", $isDisabled: i, $isReadOnly: t, $isSkeleton: o, theme: r }) => u({
  colorTheme: n,
  isDisabled: i,
  isReadOnly: t,
  isSkeleton: o,
  theme: r
})};
  border-radius: 50%;
  height: var(--size);
  transform: ${({ $isChecked: n }) => n ? "translate3d(66%, 0, 0)" : "translate3d(-66%, 0, 0)"};
  transition:
    transform ${({ theme: n }) => n == null ? void 0 : n.get("tokens.motion").toString("duration.fast")}
      ${({ theme: n }) => n == null ? void 0 : n.get("tokens.motion").toString("easing.standard")},
    background-color ${({ theme: n }) => n == null ? void 0 : n.get("tokens.motion").toString("duration.fast")}
      ${({ theme: n }) => n == null ? void 0 : n.get("tokens.motion").toString("easing.standard")};
  width: var(--size);
`;
export {
  y as Handle,
  k as Input,
  x as Label,
  b as LabelText,
  S as Switch,
  p as Toggle
};
